import { isNumericString, isRecord } from '@takeshape/util';
import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map();
const EMPTY_LIST = Immutable.List();
const NOT_SET = Symbol.for('NOT_SET');

export function updateIn<T>(
  map: Immutable.Map<string | number, any>,
  keyPath: (string | number)[],
  notSetValue: T | undefined,
  updater: (value: T | undefined) => T
): Immutable.Map<string | number, any>;
export function updateIn<T>(
  map: Immutable.Map<string | number, any>,
  keyPath: (string | number)[],
  updater: (value: T | undefined) => T
): Immutable.Map<string | number, any>;
export function updateIn<T>(
  map: Immutable.Map<string | number, any>,
  keyPath: (string | number)[],
  notSetValueOrUpdater: T | undefined | ((value: T | undefined) => T),
  updater?: (value: T | undefined) => T
): Immutable.Map<string | number, any> {
  let actualNotSetValue: T | undefined;
  let actualUpdater: (value: T | undefined) => T;

  if (typeof notSetValueOrUpdater === 'function') {
    actualUpdater = notSetValueOrUpdater as (value: T | undefined) => T;
    actualNotSetValue = undefined;
  } else {
    actualNotSetValue = notSetValueOrUpdater;
    actualUpdater = updater as (value: T | undefined) => T;
  }

  let current: any;

  const last = keyPath.length - 1;
  const refs: any[] = new Array(keyPath.length);

  for (const [i, key] of keyPath.entries()) {
    current = (current || map).get(key, NOT_SET);

    if (i === last) {
      current = actualUpdater(current === NOT_SET ? actualNotSetValue : current);
    } else if (current === NOT_SET || current === undefined) {
      current = isNumericString(String(keyPath[i + 1])) ? EMPTY_LIST : EMPTY_MAP;
    } else if (!current || !current.set) {
      throw new Error('invalid path');
    }

    refs[i] = current;
  }

  let updated = refs[last];
  for (let i = keyPath.length; i--; ) {
    updated = (refs[i - 1] || map).set(keyPath[i], updated);
  }

  return updated;
}

export function setIn<T>(
  map: Immutable.Map<string | number, any>,
  keyPath: (string | number)[],
  value: T
): Immutable.Map<string | number, any> {
  return updateIn(map, keyPath, () => value);
}
